import { useContext } from "react";
import { MobXProviderContext } from "mobx-react";
import { RouterAddress } from "../../../constants/RouterAddress";
import { ROLE_TYPE_MHP } from "../../../constants/RegisterConstants";
import { CaregiverDailyNotesPageContent } from "../../caregiver/pages/CaregiverDailyNotesPage";

const SharedResidentDailyNotesPage = () => {
  const { authStore } = useContext(MobXProviderContext);
  const userRoleType = String(authStore?.getUserRoleType?.() || "").trim().toLowerCase();
  const dashboardPathOverride = userRoleType === ROLE_TYPE_MHP ? RouterAddress.MHP_HOME : RouterAddress.NURSE_HOME;

  return (
    <CaregiverDailyNotesPageContent
      allowSharedStaffAccess
      sharedMode
      dashboardPathOverride={dashboardPathOverride}
    />
  );
};

export default SharedResidentDailyNotesPage;
